var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_15000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7299 11.5323L9.66949 8.51244L12.7299 5.49254C13.0735 5.1705 13.0911 4.63093 12.7693 4.2865C12.7565 4.27263 12.7432 4.25984 12.7299 4.24704C12.569 4.08762 12.3511 3.99858 12.1246 3.99965C11.9008 4.00071 11.6867 4.08922 11.5279 4.24704L8.4675 7.3096L5.44974 4.24704C5.29097 4.08922 5.07678 4.00071 4.85301 3.99965C4.62657 3.99858 4.40865 4.08762 4.24775 4.24704C3.91742 4.57974 3.91742 5.11718 4.24775 5.44988L7.26551 8.51244L4.24775 11.5323C3.94139 11.8901 3.98348 12.4286 4.34099 12.7352C4.66013 13.0087 5.13059 13.0087 5.44974 12.7352L8.4675 9.71529L11.4853 12.7352C11.8172 13.0791 12.3649 13.0887 12.7086 12.7565C13.0522 12.4243 13.0618 11.8762 12.7299 11.5323Z",
    fill: "#6B7482"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_15000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "matrix(1 0 0 -1 4 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.2bc629a9.svg";
export { ForwardRef as ReactComponent };